import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import AuthService from "../../../service/auth-service";
import GoogleLoginDialog from "../../dialog/google-login/GoogleLoginDialog";
import ConfirmDialog from "../../dialog/confirm/confirm-dialog";
import "./consult-float-button-style.css";

//右下角浮動的「問問老師」按鈕
//  可見性規則：
//    /personal-chart：只在頁面滑到 #seven-aspects-section 時才出現（避免擋命盤）
//    其他頁面：一律顯示
//  Auth gating：navigate 前要 login + validCode === "2"
const ConsultFloatButton = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const registerFrom = location.pathname;

  const [visible, setVisible] = useState(true);
  const [showLoginDialog, setShowLoginDialog] = useState(false);
  const [showRegisterPrompt, setShowRegisterPrompt] = useState(false);

  const askURL = "/ask-teacher";

  //命盤頁：滑到「七大面向」才顯示 button；其他頁：一律顯示
  useEffect(() => {
    const isChartPage = location.pathname === "/personal-chart";
    if (!isChartPage) {
      setVisible(true);
      return undefined;
    }

    //命盤頁預設隱藏，等 IntersectionObserver 觸發
    setVisible(false);

    let observer = null;
    let retryTimer = null;

    const tryObserve = () => {
      const target = document.getElementById("seven-aspects-section");
      if (!target) return false;
      observer = new IntersectionObserver(
        ([entry]) => setVisible(entry.isIntersecting),
        { threshold: 0.05 },
      );
      observer.observe(target);
      return true;
    };

    //target 可能還沒 render，短暫 retry 一次
    if (!tryObserve()) {
      retryTimer = setTimeout(tryObserve, 500);
    }

    return () => {
      if (retryTimer) clearTimeout(retryTimer);
      if (observer) observer.disconnect();
    };
  }, [location.pathname]);

  const handleClick = () => {
    const isLogin = AuthService.getLoginStatus();
    const profile = AuthService.getUserProfile();
    if (!isLogin || !profile) {
      setShowLoginDialog(true);
      return;
    }
    if (profile.userValidCode !== "2") {
      setShowRegisterPrompt(true);
      return;
    }
    navigate(askURL);
  };

  const handleLoginSuccess = async ({ idToken } = {}) => {
    if (!idToken) return;
    try {
      const res = await AuthService.firebaseLogin(idToken);
      if (res.data.status) {
        AuthService.login(res.data.data);
        setShowLoginDialog(false);
        if (res.data.data.userValidCode !== "2") {
          navigate("/register", { state: { from: registerFrom } });
        } else {
          navigate(askURL);
        }
      }
    } catch (e) {
      console.error("[ConsultFloatButton] firebase-login 失敗:", e);
    }
  };

  return (
    <>
      {visible && (
        <img
          className="consult-float-btn"
          src="/images/ic-question.png"
          alt="專業諮詢"
          onClick={handleClick}
        />
      )}

      {showLoginDialog && (
        <GoogleLoginDialog
          open={showLoginDialog}
          onClose={() => setShowLoginDialog(false)}
          onSuccess={handleLoginSuccess}
        />
      )}

      <ConfirmDialog
        open={showRegisterPrompt}
        onClose={() => setShowRegisterPrompt(false)}
        onSuccess={() => {
          setShowRegisterPrompt(false);
          navigate("/register", { state: { from: registerFrom } });
        }}
        title="尚未完成註冊"
        message="問問老師需要完成註冊才能使用，<br>是否前往註冊頁完成？"
        confirmTxt="前往註冊"
      />
    </>
  );
};

export default ConsultFloatButton;
